const initialState = {
  itemDetails: null,
  fetchItemDetailsPending: false,
  fetchItemDetailsError: null,
  shipToDetails: null,
  fetchShipToDetailsPending: false,
  fetchShipToDetailsError: null,
  siteList: [],
  fetchSiteInfoPending: false,
  fetchSiteInfoError: null,
};

export default initialState;


